import { CreateColumn } from '../../../Services/agGrid/createColumn';

const STATUS_LABEL = {
  '10': '접수 대기',
  '20': '처리 중',
  '30': '답변 완료',
  '40': '보류/재확인',
};

const CATEGORY_LABEL = {
  ERR: '프로그램 오류',
  IMP: '기능 개선',
  DAT: '데이터 수정',
  QNA: '단순 문의',
};

export const GetColumnDefs1 = () => [
  {
    field: 'selectRow',
    headerName: '',
    width: 56,
    minWidth: 56,
    maxWidth: 56,
    pinned: 'left',
    sortable: false,
    filter: false,
    editable: false,
    resizable: false,
    headerCheckboxSelection: true,
    checkboxSelection: true,
    cellStyle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  CreateColumn('no', '번호', 'center', 90, false, false, false, 'text', {
    minWidth: 80,
    maxWidth: 100,
  }),
  CreateColumn('categoryNm', '문의유형', 'center', 140, false, false, false, 'text', {
    minWidth: 120,
    flex: 1,
    valueFormatter: (p) => p.value || CATEGORY_LABEL[p.data?.categoryCd] || '',
  }),
  CreateColumn('title', '제목', 'left', 420, false, false, false, 'text', {
    minWidth: 280,
    flex: 3,
  }),
  CreateColumn('statusCd', '처리상태', 'center', 140, false, false, false, 'text', {
    minWidth: 120,
    flex: 1,
    valueFormatter: (p) => STATUS_LABEL[p.value] || p.data?.statusNm || '',
  }),
  CreateColumn('createNm', '작성자', 'center', 130, false, false, false, 'text', {
    minWidth: 110,
    flex: 1,
  }),
  CreateColumn('createDate', '등록일', 'center', 160, false, false, false, 'text', {
    minWidth: 140,
    flex: 1,
  }),
];

export const HelpDeskStatusItems = [
  { value: '', name: '전체' },
  { value: '10', name: '접수 대기' },
  { value: '20', name: '처리 중' },
  { value: '30', name: '답변 완료' },
  { value: '40', name: '보류/재확인' },
];

export const HelpDeskCategoryItems = [
  { value: '', name: '전체' },
  { value: 'ERR', name: '프로그램 오류' },
  { value: 'IMP', name: '기능 개선' },
  { value: 'DAT', name: '데이터 수정' },
  { value: 'QNA', name: '단순 문의' },
];

export const HelpDeskCategoryStatsColors = {
  ERR: '#d32f2f',
  IMP: '#1976d2',
  DAT: '#ed6c02',
  QNA: '#2e7d32',
};

export const BuildCategoryStats = (rows = []) => {
  const counts = { ERR: 0, IMP: 0, DAT: 0, QNA: 0 };

  (rows || []).forEach((row) => {
    const cd = String(row?.categoryCd || row?.CategoryCd || 'QNA').toUpperCase();
    if (Object.prototype.hasOwnProperty.call(counts, cd)) {
      counts[cd] += 1;
    } else {
      counts.QNA += 1;
    }
  });

  return HelpDeskCategoryItems.filter((item) => item.value).map((item) => ({
    name: item.name,
    code: item.value,
    value: counts[item.value] ?? 0,
  }));
};
